import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';

import {
  FDBodyText, FDChartLegend,
  FDStack,
} from '@facet-wealth/design';
import { DataSetCollection } from 'Organisms/DataSet';

import QuestionResponse from './QuestionResponse';


const Quiz = ({ quiz }) => (
  <FDStack direction={'column'} spacing={3}>
    <FDBodyText color={'textSecondary'} value={quiz.attr('description')} />
    {quiz.attr('questionResponses')?.resources().list().map((questionResponse) => (
      <QuestionResponse questionResponse={questionResponse} key={questionResponse.id()} />
    ))}
    {quiz.attr('dataSet') && (
      <DataSetCollection collection={quiz.attr('dataSet')} dataSetHeight={400} ChartLegend={FDChartLegend} showAxisLine />
    )}
  </FDStack>
);

Quiz.propTypes = {
  quiz: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default Quiz;
